<template>
  <div>
    <multiselect v-model="localModel" id="ajaxEntrepreneur" @input="onChange"  :custom-label="entrepreneurLabel" 
      track-by="id" :placeholder="$t('project.company.form.entrepreneur.name')" open-direction="bottom" 
      :options="entrepreneurs" :multiple="false" :searchable="true" :loading="isLoadingEntrepreneur" 
      :internal-search="false" :clear-on-select="true" :close-on-select="true" 
      :options-limit="300" :max-height="600" :show-no-results="true" 
      :hide-selected="true" @search-change="asyncFindEntrepreneur"
      v-bind:deselect-label="$t('multiselect.deselect-label')"
      v-bind:selectedLabel="$t('multiselect.selectedLabel')"
      v-bind:select-label="$t('multiselect.select-label')">
      <span slot="noResult">{{ $t('multiselect.not-found') }} </span>
    </multiselect>
  </div>
</template>

<script>
  import {EntrepreneurServiceClient, EntrepreneurDto} from '../../shared/service-clients/service-clients'
  import ServiceFactory from '../../shared/service-clients/serviceClientFactory'
  import Multiselect from 'vue-multiselect'

  export default {
    name: 'EntrepreneurMultiselect',
    props: {
      model: {},
    },
    watch: {
      model: {
        immediate: true,
        handler(newVal, oldVal) {
          this.localModel = newVal
        },
      },
    },
    data() {
      return {
        localModel: {},
        entrepreneurs: [],
        isLoadingEntrepreneur: false,
      }
    },
    inject: ['$validator'],
    methods: {
      onChange(value) {
        this.$emit('update', value)
      },
      entrepreneurLabel: function(obj) {
        return obj.familyName + ', ' + obj.name
      },
      asyncFindEntrepreneur: function(query) {
        this.isLoadingEntrepreneur = true
  
        let service = ServiceFactory.create(EntrepreneurServiceClient)
        let self = this

        service.getAutocomplete(query).then(response => {
          self.entrepreneurs = response
          self.isLoadingEntrepreneur = false
        })
      },
    },
    components: {
      multiselect: Multiselect,
    },
  }
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
</style>



// WEBPACK FOOTER //
// src/shared/multiselect/EntrepreneurMultiselect.vue